var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeControlledAgentFriendlyOrdering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.876 511.876",
    height: 512,
    viewBox: "0 0 511.876 511.876",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.922 496.876h472.033",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.456 114.047h107.996v382.67h-107.996z",
    fill: "#5a5f64"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m382.888 0-126.95 35.594-10 251.543 10 209.58h126.95z",
    fill: "#4bb7ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.989 71.188v425.529h126.949v-461.123z",
    fill: "#7ac6ee"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f5f0eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m274.459 250.516h30v60.341h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.459 140.314h30v60.341h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.459 360.718h30v60.341h-30z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m51.425 173.138h158.419v323.579h-158.419z",
    fill: "#fdd278"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff7f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m115.635 250.516h30v60.341h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.635 360.718h30v60.341h-30z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m491.955 481.876h-236.017l-10 14.841 10 15.159h236.017z",
    fill: "#7bc5b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.922 481.876h236.016v30h-236.016z",
    fill: "#9edba7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeControlledAgentFriendlyOrdering);
export default __webpack_public_path__ + "static/media/office-controlled-agent-friendly-ordering.ea6fec31e42175a806a46977c05527a1.svg";
export { ForwardRef as ReactComponent };